<template>
  <div class="gdpr-notice">
    <p class="gdpr-notice__text">
      We use cookies and similar technologies to improve your browsing experience on our website, to
      show you personalized content and targeted ads, to analyze our website traffic, and to
      understand where our visitors are coming from. By browsing our website, you consent to our use
      of cookies and other tracking technologies. Read our
      <a
        :href="privacyUrl"
        target="_blank"
        rel="noopener noreferrer"
        >Privacy Notice</a
      >
      and
      <a
        :href="cookiesUrl"
        target="_blank"
        rel="noopener noreferrer"
        >Cookie Policy</a
      >
      for more information.
    </p>
    <div class="gdpr-notice__actions">
      <q-btn
        label="I Accept"
        unelevated
        no-caps
        class="gdpr-btn gdpr-btn--accept"
        @click="emit('accept')"
      />
      <q-btn
        v-if="showManage"
        label="Manage my cookies"
        unelevated
        no-caps
        outline
        class="gdpr-btn gdpr-btn--manage"
        @click="emit('manage')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  privacyUrl: string
  cookiesUrl: string
  showManage: boolean
}>()

const emit = defineEmits<{
  (e: 'accept'): void
  (e: 'manage'): void
}>()
</script>

<style scoped>
.gdpr-notice__text {
  font-size: 14px;
  color: #1d1d1d;
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.gdpr-notice__text a {
  color: #e4610f;
  text-decoration: underline;
}

.gdpr-notice__actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
</style>
